var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8214 41.8551L46.4391 24.0552C46.754 22.5162 46.3581 20.9324 45.3684 19.7175C44.3692 18.5028 42.9025 17.8007 41.3274 17.8007H32.6161L34.047 10.7722C34.3709 9.14324 33.957 7.4695 32.9129 6.19155C31.8602 4.90455 30.3032 4.16675 28.6384 4.16675H27.1896C26.0645 4.16675 25.1466 5.07558 25.1466 6.19155C25.1466 8.61216 24.2378 14.9476 15.9405 21.3101L15.5895 21.5802V42.4762L17.6953 44.069C18.9104 44.9869 20.4221 45.4908 21.943 45.4908H38.3661C40.5174 45.4912 42.3894 43.9613 42.8214 41.8555L42.8214 41.8551Z",
    fill: "#10B981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4043 45.8334H4.72808V45.833C3.95407 45.833 3.33337 45.2119 3.33337 44.4473V21.2026C3.33337 20.4289 3.95409 19.8079 4.72808 19.8079H12.4043C13.1693 19.8079 13.7903 20.4286 13.7903 21.2026V44.4473C13.7903 45.2123 13.1693 45.8334 12.4043 45.8334ZM11.1893 39.9747C11.1893 38.7691 10.2176 37.797 9.02067 37.797C7.81504 37.797 6.83388 38.7691 6.83388 39.9747C6.83388 41.1894 7.81466 42.1615 9.02067 42.1615C10.2176 42.1615 11.1893 41.1898 11.1893 39.9747ZM9.08242 27.0904C10.3405 27.0904 11.3603 26.0705 11.3603 24.8125C11.3603 23.5544 10.3405 22.5346 9.08242 22.5346C7.82437 22.5346 6.80452 23.5544 6.80452 24.8125C6.80452 26.0705 7.82437 27.0904 9.08242 27.0904Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterested);
export default __webpack_public_path__ + "static/media/Interested.ca542216353fab398761b8bcf8dc5bd7.svg";
export { ForwardRef as ReactComponent };